export const Developer = () => (
  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.67018 14.5002L10.4202 0.750244M13.7535 4.08358L15.7967 6.25453C16.5215 7.02463 16.5215 8.22589 15.7967 8.99599L13.7535 11.1669M3.33684 11.1669L1.29361 8.99599C0.56881 8.22589 0.568807 7.02463 1.2936 6.25453L3.33684 4.08358"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Developer
